import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import theme from './theme';
import { ThemeProvider } from '@mui/material/styles';

const root = ReactDOM.createRoot(document.getElementById('root'));

// 🔴 Automated Server Down UI
const ServerDown = () => {
  return (
    <div style={{
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      background: "#0f172a",
      color: "#e2e8f0",
      fontFamily: "monospace",
      textAlign: "center",
      padding: "20px"
    }}>
      <h1 style={{ fontSize: "28px", marginBottom: "10px", color: 'white' }}>
        ⚠ SYSTEM STATUS: UNAVAILABLE
      </h1>
      <p style={{ opacity: 0.8 }}>
        Automated monitoring has detected a service disruption.
      </p>
      <p style={{ marginTop: "10px", opacity: 0.6 }}>
        Error Code: SRV-503 | Skyline Gateway
      </p>
      <p style={{ marginTop: "20px", fontSize: "12px", opacity: 0.4 }}>
        This is an automated message. Please try again later.
      </p>
    </div>
  );
};

// 🟡 Loader UI
const Loader = () => {
  return (
    <div style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "monospace"
    }}>
      Initializing system...
    </div>
  );
};

// 🟢 Root Controller
const RootController = () => {
  const [status, setStatus] = useState("loading"); // loading | up | down

  useEffect(() => {
    fetch("https://api.iskconsolapur.org/api/fetch/global-form/skyline-properties/isBillPaid")
      .then(res => res.json())
      .then(data => {
        const isUp = data?.data?.[0]?.status;
        setStatus(isUp ? "up" : "down");
      })
      .catch(() => {
        setStatus("down"); // fail-safe
      });
  }, []);

  if (status === "loading") return <Loader />;
  if (status === "down") return <ServerDown />;

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  );
};

root.render(<RootController />);

// ✅ Keep your service worker + vitals intact
serviceWorkerRegistration.register();
reportWebVitals();